export { SearchWidgetV2 } from './SearchWidgetV2';
